<template>
<v-layout row wrap>   
    <v-flex xs12 v-if="variety.activeProfile.BerriesForecastProfileID">
        <adjustment-edit-control :label="'Profile Start Date'" :value="profileStartDate" @increment="handleIncrementProfileStartDate" @decrement="handleDecrementProfileStartDate"></adjustment-edit-control>
    </v-flex>
    <v-flex xs12>
        <adjustment-edit-control 
            :label="'Next Pick Date'" 
            :value="nextPickDate" 
            @increment="handleIncrementNextPickDate" 
            @decrement="handleDecrementNextPickDate"
            @click="openNextPickDatePicker">
        </adjustment-edit-control>
        <v-dialog
            v-if="showNextPickDatePicker"
            :value="true"
            persistent
            width="290px">
            <v-date-picker
                :first-day-of-week="1"
                :value="nextPickDatePickerValue"
                @input="updateNextPickDatePickerValue">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="cancelNextPickDatePicker()">Cancel</v-btn>
                <v-btn text color="primary" @click="submitNextPickDatePicker()">OK</v-btn>
            </v-date-picker>
        </v-dialog>
    </v-flex>
    <v-flex xs12 v-if="variety.activeProfile.BerriesForecastProfileID">
        <adjustment-edit-control :label="'Estimated Yield per Hectare (Tonnes)'" :value="tonnesPerHectare" @increment="handleIncrementTonnesPerHectare" @decrement="handleDecrementTonnesPerHectare"></adjustment-edit-control>
    </v-flex>
    <v-flex xs12>
        <adjustment-edit-control :label="'Current Rotation (Days)'" :value="rotationDays" @increment="handleIncrementRotationDays" @decrement="handleDecrementRotationDays"></adjustment-edit-control>
    </v-flex>
    <no-data v-if="!variety.activeProfile.CropArea" message="Crop variety has no area defined"></no-data>
    <v-layout row wrap v-if="variety.activeProfile.BerriesForecastProfileID && variety.activeProfile.CropArea">
        <v-flex xs12 pt-4 pb-3>
            <v-divider></v-divider>
        </v-flex>
        <v-flex xs6>        
            <span>{{ `Variety Area (ha) : ${formatedArea}` }}</span>
        </v-flex>
        <v-flex xs6>
            <span>{{ `Yield expected: ${formatedExpectedYield} KG` }}</span>
        </v-flex>
        <v-flex xs6>
            <span>Last Pick: {{ formatLastPick }} KG</span>
        </v-flex>
        <v-flex xs6>
            <span>Current Yield: {{ formatCurrentYield }} KG</span>
        </v-flex>
        <v-flex xs6>
            <span>Current KG per Ha: {{ formatCurrentKgPerHa }} KG</span>
        </v-flex>
        <v-flex xs12 pt-3 pb-3>
            <v-divider></v-divider>
        </v-flex>
    </v-layout>
</v-layout>
</template>

<script>
import AdjustmentEditControl from '@/components/forecasting/forecastingProfile/AdjustmentEditControl.vue'
import NoData from '@/components/generic/NoData.vue';
import moment from 'moment';

export default {
    components: {
        AdjustmentEditControl,
        NoData
    },
    props: {
        crop: {
            type: Object,
            required: true
        },
        variety: {
            type: Object,
            required: true
        },
        forecasts: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            showNextPickDatePicker: false,
            nextPickDatePickerValue: null
        }
    },
    computed: {
        formatedArea() {
            return (this.variety.activeProfile.CropArea || '').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        formatedExpectedYield() {
            return (this.variety.activeProfile.TonnesPerHectare * this.variety.activeProfile.CropArea * 1000).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        formatLastPick() {
            return (this.variety.lastPickActualValue || 0).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        formatCurrentYield() {
            if (this.forecasts && this.forecasts.length > 0) {
                return (this.forecasts.map(f => f.ActualValue).reduce((a, b) => a + b) || 0).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

            return 0;
        },
        formatCurrentKgPerHa() {
            if (this.forecasts && this.forecasts.length > 0) {
                return (this.forecasts.map(f => f.ActualValue).reduce((a, b) => a + b) / this.variety.activeProfile.CropArea).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }

            return 0;
        },
        profileStartDate() {
            let val = "";

            if (this.variety.activeProfile && this.variety.activeProfile.StartYear && this.variety.activeProfile.StartWeek) {
                val = `FY${this.variety.activeProfile.StartYear} WK${this.variety.activeProfile.StartWeek}`;
            }

            return val;
        },
        nextPickDate() {
            let val = moment(this.variety.manualNextPickDate || this.variety.nextPickDateWithoutRotation).add(this.variety.rotationDays || 0, 'days');
            return this.$options.filters.formatDate(val);
        },
        tonnesPerHectare() {
            let val = "";

            if (this.variety.activeProfile && this.variety.activeProfile.TonnesPerHectare != null) {
                val = this.variety.activeProfile.TonnesPerHectare.toString();
            }

            return val;

        },
        rotationDays() {
            let val = "";

            if (this.variety.rotationDays != null) {
                val = this.variety.rotationDays.toString();
            }

            return val;
        }
    },
    methods: {
        openNextPickDatePicker(){
            this.nextPickDatePickerValue = moment(this.variety.manualNextPickDate || this.variety.nextPickDateWithoutRotation).add(this.variety.rotationDays || 0, 'days').format('YYYY-MM-DD');
            this.showNextPickDatePicker = true;
        },
        updateNextPickDatePickerValue(newValue){
            this.nextPickDatePickerValue = moment(newValue, "YYYY-MM-DD").format('YYYY-MM-DD');
        },
        cancelNextPickDatePicker(){
            this.nextPickDatePickerValue = null;
            this.showNextPickDatePicker = false;
        },
        submitNextPickDatePicker(){
            this.variety.manualNextPickDate = moment(this.nextPickDatePickerValue, "YYYY-MM-DD").add(-this.variety.rotationDays || 0, 'days').format('YYYY-MM-DD');
            this.nextPickDatePickerValue = null;
            this.showNextPickDatePicker = false;
        },
        handleIncrementProfileStartDate() {
            let week = this.variety.activeProfile.StartWeek;
            let year = this.variety.activeProfile.StartYear;

            week += 1;

            if(week > 52) {
                year += 1;
                week = 1;
            }

            this.variety.activeProfile.StartWeek = week;
            this.variety.activeProfile.StartYear = year;
        },
        handleDecrementProfileStartDate() {
            let week = this.variety.activeProfile.StartWeek;
            let year = this.variety.activeProfile.StartYear;

            week -= 1;

            if(week == 0) {
                year -= 1;
                week = 52;
            }

            this.variety.activeProfile.StartWeek = week;
            this.variety.activeProfile.StartYear = year;

        },
        handleIncrementNextPickDate() {            
            this.variety.manualNextPickDate = moment(this.variety.manualNextPickDate || this.variety.nextPickDateWithoutRotation).add(1, 'days').format('YYYY-MM-DD');
        },
        handleDecrementNextPickDate() {
            this.variety.manualNextPickDate = moment(this.variety.manualNextPickDate || this.variety.nextPickDateWithoutRotation).add(-1, 'days').format('YYYY-MM-DD');
        },
        handleIncrementTonnesPerHectare() {
            this.variety.activeProfile.TonnesPerHectare += 0.5;
        },
        handleDecrementTonnesPerHectare() {
            if ((this.variety.activeProfile.TonnesPerHectare || 0) === 0) {
                return;
            }
            
            this.variety.activeProfile.TonnesPerHectare -= 0.5;
        },
        handleIncrementRotationDays() {            
            this.variety.rotationDays = (this.variety.rotationDays || 0) + 1;
        },
        handleDecrementRotationDays() {            
            if ((this.variety.rotationDays || 0) <= 1) {
                return;
            }

            this.variety.rotationDays = (this.variety.rotationDays || 0) - 1;            
        }
    }
}
</script>
